
import React, {lazy,Suspense} from 'react'
import SVApp from './SVApp'
//import configureStore from './store'
import configureStore from './redux/SVStore'
import { Provider } from 'react-redux'
import {StaticRouter} from 'react-router'

//import {Switch,Route} from 'react-router'
import { CookiesProvider } from 'react-cookie'
//import RouteConfigExample from './RouterConfig'
//import SVRegusConfig from './RouterSVRegus'
//import SVMyAccountConfig from './RouterSVMyAccount'
//import RouterTacossvExample from './RouterTacossv'
//import { BrowserRouter as Router, Route, Link } from "react-router-dom"

//import RouterAmcossvExample from './RouterAmcossv'



import Header  from './components/Header'

import About from './views/About'

import Home from './views/Home'
/*router genereric and hsitory go together */
//
import { Router } from "react-router-dom";
import history from "./history"
import RouterAmcossvExample from './RouterAmcossv'
/*
import  {SVNav} from './components/nav/SVNav'
*/
/*
import {BrowserRouter as Router , history} from 'react-router-dom'
*/

/* this is s[eciality router and historuy will work in the components only]
import { Router, Redirect } from "react-router"
import { createBrowserHistory } from "history"
const history = createBrowserHistory();
*/
/*
import {AddressesCom} from './containers'
import { ReguserContainerCom} from './containers'

import {RegusersCom,StoredcardsWithCustprofile,LoginabodeContainerCom,PwrresetContainerCom } from './containers'
//import SVMyResHome from './components/accountsabode/accountcontainer/svmyreshome'
import SVMyResHome from './components/accountsabode/accountcontainer/svmyreshome'

*/


/*
import App from './App'
import { CookiesProvider } from 'react-cookie'


import { Router } from "react-router";
import { Switch, Route, IndexRoute } from "react-router-dom"
import {ReguserContainerCom,RegusersCom,StoredcardsWithCustprofile,LoginabodeContainerCom,PwrresetContainerCom } from './containers'

*/
 
/*
 const store = configureStore();
*/

const store = configureStore();
 /*
 
 const history = createBrowserHistory();
  //const StoredcardsWithCustprofileLazy = lazy(()=> StoredcardsWithCustprofile);
 const ReguserContainerComLazy = lazy(()=>ReguserContainerCom )

 //ReguserContainerComLazy
 const LoginabodeContainerComLazy = lazy(()=>LoginabodeContainerCom )
 const PwrresetContainerComLazy = lazy(()=>PwrresetContainerCom)

 const RegusersComLazy = lazy(()=>RegusersCom)
 const Root = () => (
    <CookiesProvider>
        <Provider store={store}>
            <Router history={history}>
                    <Switch>
                        <Route exact path="/" component={() => <h1>Root</h1>} />
                        <Route exact path="/test" component={() => <h1>Test</h1>} />
                       
                        <Route exact path="/myaccountSV/:id"  component={ReguserContainerComLazy}  />
                           
                       
                        <Route exact path="/svregus"  component={RegusersComLazy}  />
                        <Route exact path="/svreguser/:id"  component={ReguserContainerComLazy}  />
                        <Route exact path="/svregus/svlogin" component={LoginabodeContainerComLazy} />
                        <Route exact path="/svregus/svepwr" component={PwrresetContainerComLazy} />
                           
                    </Switch>
            </Router>
        </Provider>
    </CookiesProvider>
   
    )
*/
/*
 <Route exact path="/myaccountSV/:id/mystoredcardList"  component={StoredcardsWithCustprofileLazy} />
                       

 const Root = () => (
    <CookiesProvider>
        <Provider store={store}>
            <Router history={history}>
                    <Switch>
                        <Route exact path="/" component={() => <h1>Root</h1>} />
                        <Route exact path="/test" component={() => <h1>Test</h1>} />
                         
                        <Route exact path="/myaccount/:id/mystoredcardList"component={() => <StoredcardsWithCustprofile />} /> 
                           

                        <Route exact path="/myaccountSV/:id"  component={ReguserContainerComLazy}  />
                           
                        <Route exact path="/myaccountSV/:id/mystoredcardList"  component={StoredcardsWithCustprofileLazy} />
                       
                        <Route exact path="/svregus"  component={RegusersComLazy}  />
                        <Route exact path="/svreguser/:id"  component={ReguserContainerComLazy}  />
                        <Route exact path="/svregus/svlogin" component={LoginabodeContainerComLazy} />
                        <Route exact path="/svregus/svepwr" component={PwrresetContainerComLazy} />
                           
                    </Switch>
            </Router>
        </Provider>
    </CookiesProvider>
    )

*/
/*
const Root = () => (
    <CookiesProvider>
        <Provider store={store}>
            <App />
        </Provider>
    </CookiesProvider>
    )
  
*/

/*
const Root = () => (
    <CookiesProvider>
        <Provider store={store}>
            <SVApp />
        </Provider>
    </CookiesProvider>
    )
*/
/*
 <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={App}>
        <Route path="foo" component={Foo}/>
        <Route path="bar" component={Bar}/>
      </Route>
    </Router>
  </Provider>

*/
/*
browserHistory.listen((data) => {
   
    window.scrollTo(0, 0)
  })
  */

const {noop} = StaticRouter
/*working on March24 useParams send  all url Prams that yu know pass
const Root = () => (
    <noop>
       
        { RouteConfigExample()}
    </noop>
    )
       
              

*/
const Root = () => (
    <noop>
       <CookiesProvider>
            <Provider store={store}>
    
        
                <Router history={history}> 
               
                { RouterAmcossvExample()}
                </Router>
            </Provider>
    </CookiesProvider>
              
                          
                            
                                  {/* 
                                  <Route exact path="/svaddrs" component={AddressesCom} />
                                
                                   
                                  <Route  exact path="/svregus/svreguser/:id" component={ReguserContainerCom} /> 
                                    <Route exact path="/svregus/svlogin" component={LoginabodeContainerCom} />
                                    <Route exact path="/svregus/svlogin" component={LoginabodeContainerCom} />
                                    <Route exact path="/svregus"  component={RegusersCom}  />
                                    <Route path="/svregus/svepwr" component={PwrresetContainerCom} />
                                    

                                    Outside switch
                                     <Route exact path="/myaccountSV/:id"  component={ReguserContainerCom}  />
                                 
                                    /svregus/
                                     <Route exact  path="/svhome" component={SVMyResHome} /> 
                                  <Route exact path="/about" component={About}  />
                                  */}
                                   
                                  
                                  
                                    
                                    
                               

           
       
    </noop>
    )
  
export default Root